import request from "@/utils/request";
import {subjectCd1, subjectCd2, subjectCd3} from "@/utils/Constants";

let contentsList = [];
const initContentsList = function(params) {
    console.log('initContentsList params:', params);
    const count = parseInt(params.limit);
    for (const index in [...Array(count)]) {
        const seq = parseInt(index) + 1;
        if (params.bookTypeCd == '330004') {
            const item = {bookSeq:seq == 1 ? 559 : seq, 
                contSeq:seq == 1 ? 26382 : seq,
                textbookNm:'국어교재', 
                subjectNm:'국어',
                subjectCd:subjectCd1[3].value, 
                schlE1ChkYn:'Y', schlE2ChkYn:'N', schlE3ChkYn:'N',
                schlE4ChkYn:'Y', schlE5ChkYn:'N', schlE6ChkYn:'N',
                schlM1ChkYn:'N', schlM2ChkYn:'N', schlM3ChkYn:'N',
                schlH1ChkYn:'N', schlH2ChkYn:'N', schlH3ChkYn:'N',
                keywords:`키_${seq},키_${seq}_2`,
                adminId: index == 0 ? 'admin' : 'admin5',
                useYn:'Y', 
                regId:`regId_${seq}`, regDt:'2022-05-01',
                updDt:'2022-05-13', updId:`updId_${seq}`};
            contentsList.push(item);
        } else { // 330005
            const item = {bookSeq:seq == 1 ? 559 : seq, 
                contSeq:seq == 1 ? 26382 : seq,
                thumbImageUrl:'https://spnimage.edaily.co.kr/images/Photo/files/NP/S/2020/10/PS20100800026.jpg',
                thumbImageName: '영어강좌_예제.pdf',
                textbookNm:'영어 강좌 [말하기 및 듣기]',
                subjectNm:'영어', 
                studyCycle:seq == 1 ? 'YYNNYYY' : 'NNNNYYY',
                subjectCd:subjectCd2[2].value, 
                schlE1ChkYn:'N', schlE2ChkYn:'N', schlE3ChkYn:'N',
                schlE4ChkYn:'N', schlE5ChkYn:'N', schlE6ChkYn:'N',
                schlM1ChkYn:'N', schlM2ChkYn:'Y', schlM3ChkYn:'Y',
                schlH1ChkYn:'N', schlH2ChkYn:'N', schlH3ChkYn:'N',
                keywords:`키22_${seq},키22_${seq}_2`,
                adminId: index == 0 ? 'admin' : 'admin6',
                useYn:'Y', 
                summary : '강좌 Summary',
                description : '강좌 설명입니다. 설명일까요?',
                classFileUrl: 'https://spnimage.edaily.co.kr/images/Photo/files/NP/S/2020/10/PS20100800026.jpg',
                classFileName: '소개자료.pdf',
                regId:`regId_${seq}`, regDt:'2022-06-01',
                updDt:'2022-06-13', updId:`updId_${seq}`};
            contentsList.push(item);
        } 
    }
}

const getTestContentsList = async function(params) {
    console.log('getTestCustContentsList:', params.limit);

    contentsList.splice(0, contentsList.length);
    initContentsList(params);
    const result = {
        data: contentsList,
        count: contentsList.length
    }
    console.log('contentsList result:', result);
    return result;
}

const getTestContentsDetail = async function(bookSeq) {
    const seq = bookSeq;
    const detailItem = contentsList.filter((item) => item.bookSeq = seq);

    return {data:detailItem};
}

// =========================== 맞춤콘텐츠 ===========================
// 맞춤콘텐츠 목록
export async function getCustContentsList(params, isTest) {
    console.log("@@ get list : getCustContentsList");
    if (isTest) {
        params.bookTypeCd = '330004';
        return getTestContentsList(params);
    } else {
        return request.get("/api/lm/lmTextBook/customCont",{params});
    }
}

// 맞춤콘텐츠 등록, 수정은 saveLmTextBook() 사용
export async function saveNewCustContents(params, isTest) {
    console.log("@@ get Item : saveNewCustContents");
    return request.post(`/api/lm/lmTextBook/newCustomCont`, params);
}

// 맞춤콘텐츠 상세
export async function getCustContentsDetail(bookSeq, isTest) {
    console.log("@@ get Item : getCustContentsDetail");
    return isTest ? getTestContentsDetail(bookSeq) : request.get(`/api/lm/lmTextBook/customCont/${bookSeq}`);
}

// 맞춤콘텐츠 삭제
export async function deleteCustContents(params) {
    console.log("@@ delete : deleteCustContents");
    let result = request.delete(`/api/lm/lmTextBook/customCont/${params.bookSeq}`);
    return result;
}

// =========================== 맞춤강좌 ===========================
// 맞춤강좌 목록
export async function getCustClassList(params, isTest) {
    console.log("@@ get list : getCustClassList");
    if (isTest) {
        params.bookTypeCd = '330005';
        return getTestContentsList(params);
    } else {
        return request.get("/api/lm/lmTextBook/customLecture",{params});
    }
}

// 맞춤강좌 등록,수정 모두 사용
export async function saveCustomClass(params, isTest) {
    console.log("@@ get Item : saveCustomClass");
    return request.post(`/api/lm/lmTextBook/saveCustomLecture`, params);
}

// 맞춤강좌 상세
export async function getCustClassDetail(bookSeq, isTest) {
    console.log("@@ get Item : getCustClassDetail");
    return isTest ? getTestContentsDetail(bookSeq) : request.get(`/api/lm/lmTextBook/customLecture/${bookSeq}`);
}

// 맞춤강좌 삭제
export async function deleteCustClass(params) {
    console.log("@@ delete : deleteCustClass");
    let result = request.delete(`/api/lm/lmTextBook/customLecture/${params.bookSeq}`);
    return result;
}

// =========================== 교과서, 참고서 ===========================
export async function getLmTextBookList(params, isTest) {
    console.log("@@ get list : getLmTextBookList");
    return request.get("/api/lm/lmTextBook/",{params});
}

export async function getLmTextBookItem(params, isTest) {
    console.log("@@ get item : getLmTextBookItem");
    return request.get(`/api/lm/lmTextBook/${params.bookSeq}`,{params} );
}

export async function getLmTextBookItemInfo(params) {
    console.log("@@ get item : getLmTextBookItem");
    let result = request.get(`/api/lm/lmTextBook/0`,{params} );
    return result;
}

export async function saveLmTextBook(params) {
    console.log("@@ post save : saveLmTextBook");
    let result = request.post(`/api/lm/lmTextBook/`,params);
    return result;
}
//NOTUSED 230317
//export async function saveNewLmTextBook(params) {
//    console.log("@@ post save : saveNewLmTextBook");
//    let result = request.post(`/api/lm/lmTextBook/newBook`,params);
//    return result;
//}

export async function deleteLmTextBook(params) {
    console.log("@@ delete : deleteLmTextBook");
    let result = request.delete(`/api/lm/lmTextBook/${params.bookSeq}`,{params});
    return result;
}

export async function saveTextbook(params) {
    console.log("@@ post save : 교재 saveTextbook");
    let result = request.post(`/api/lm/lmTextBook/saveTextbook/`,params);
    return result;
}

export async function saveNewTextbookContents(params) {
    console.log("@@ post save : 교재 saveNewTextbookContents");
    let result = request.post(`/api/lm/lmTextBook/saveNewTextbookContents/`,params);
    return result;
}
export async function updateTextbookContents(params) {
    console.log("@@ post save : 교재 updateTextbookContents");
    let result = request.post(`/api/lm/lmTextBook/updateTextbookContents/`,params);
    return result;
}

export async function saveReferenceTextbook(params) {
    console.log("@@ post save : ycloud 참고서 saveReferenceBook");
    let result = request.post(`/api/lm/lmTextBook/saveReferenceBook/`,params);
    return result;
}

export async function saveYcloudTextbook(params) {
    console.log("@@ post save : 교재 ycloudTextbook");
    let result = request.post(`/api/lm/lmTextBook/ycloudTextbook/`,params);
    return result;
}

export async function getLmTextBookListSchlGrade(params) {
    console.log("@@ get list : getLmTextBookList to schoolGrade");
    let result = request.get("/api/lm/lmTextBook/searchGrade",{params});
    return result;
}